export default __webpack_public_path__ + "static/media/0.9def6581.png";